// NotFound.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTools, FaExclamationTriangle } from "react-icons/fa";
import { MdOutlineConstruction } from "react-icons/md";
import { useTheme } from "styled-components";
import { BtnGeneral } from "../../styles/Buttons";
import { Container, Icons, Title, Highlight, Text, } from "./NotFound.styles";
import useAuth from "../../hooks/useAuth";

export default function NotFound() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { getDefaultRoute } = useAuth();

  return (
    <Container>
      <Icons>
        <FaExclamationTriangle size={60} color={theme.icon404} />
        <MdOutlineConstruction size={80} />
        <FaTools size={60} color={theme.icon404} />
      </Icons>

      <Title>
        ESTE SITIO WEB ESTÁ EN <Highlight>CONSTRUCCIÓN</Highlight>
      </Title>

      <Text>
        Estamos trabajando para brindarte una mejor experiencia. Por favor,
        vuelve pronto.
      </Text>

      <BtnGeneral bg="yellow" padding="12px 24px" radius="6px" fw="bold" mgb="30px" trbg="background-color 0.3s ease"
      onClick={() => navigate(typeof getDefaultRoute === "function" ? getDefaultRoute() : "/")}>Volver al Inicio</BtnGeneral>
    </Container>
  );
}
